import { useEffect, useState } from "react";
import useOrderItemsFromApiStore from "../store/orderItemsFromApiStore";
import plusIcon from "../assets/plusIcon.png";
import { FaMinusSquare } from "react-icons/fa";
import useOrderItemsLoadStore from "../store/orderItemsLoadStore";

const AddOrderLoad = () => {
  const { orderItemsFromApi, getAllOrderItemsFromApi } =
    useOrderItemsFromApiStore();
  const {
    orderItemsLoad,
    addOrderItemLoad,
    clearOrderItemsLoad,
    removeOrderLoadItem,
  } = useOrderItemsLoadStore();
  const [selectedItem, setSelectedItem] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unitValue, setUnitValue] = useState("");
  const [targetValue, setTargetValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getAllOrderItemsFromApi();
  }, [getAllOrderItemsFromApi]);

  useEffect(() => {
    if (!selectedItem) return;

    const priceAndQuantity = [];
    let myQuantity = Number(quantity);

    let currentQuantity = 0;

    const clonedItem = [...selectedItem.orderItemsDetails];

    for (const item of clonedItem) {
      if (currentQuantity < myQuantity) {
        const remainingSpace = myQuantity - currentQuantity;

        if (item.remaining_quantity > remainingSpace) {
          priceAndQuantity.push({
            ...item,
            remaining_quantity: remainingSpace,
          });
          currentQuantity += remainingSpace;
          break;
        } else {
          priceAndQuantity.push(item);
          currentQuantity += item.remaining_quantity;
        }
      }
    }

    let totalSumTargetValue = 0;
    let totalSumUnitValue = 0;
    let totalSumDollarCost = 0;
    let totalQuantity = 0;
    let totalValue = 0;

    for (const item of priceAndQuantity) {
      totalSumTargetValue += item.remaining_quantity * item.target_value;
      totalSumUnitValue += item.remaining_quantity * item.unit_value;

      totalSumDollarCost +=
        item.remaining_quantity *
        item.target_value *
        item.order.average_dollar_cost;

      totalValue += item.remaining_quantity * item.target_value;
      totalQuantity += item.remaining_quantity;
    }

    const averageTargetValue = totalSumTargetValue / totalQuantity;
    const averageUnitValue = totalSumUnitValue / totalQuantity;
    const averageDollarCost = totalSumDollarCost / totalValue;

    if (totalQuantity < myQuantity) {
      alert(`Quantidade máxima disponível: ${totalQuantity}`);
      setQuantity(totalQuantity);
    }

    setTargetValue(averageTargetValue?.toFixed(2) || "");
    setUnitValue(averageUnitValue?.toFixed(2));

    setSelectedItem((state) => ({
      ...state,
      averageDollarCost,
      orderItemsInfo: priceAndQuantity,
    }));
  }, [quantity]);

  const onHandleAddOrderLoadItems = () => {
    if (!selectedItem.id || !quantity || !targetValue || !unitValue) {
      setErrorMessage("Por favor, preencha todos os campos");
      return;
    }

    setErrorMessage("");
    const newItem = {
      order_item_id: selectedItem.id,
      name: selectedItem.product_name,
      quantity: parseInt(quantity, 10),
      target_value: parseFloat(targetValue).toFixed(2),
      unit_value: parseFloat(unitValue).toFixed(2),
      total_value: (quantity * targetValue).toFixed(2),
      average_dollar_cost: selectedItem.averageDollarCost.toFixed(2),
      total_value_in_real: (
        selectedItem.averageDollarCost *
        (quantity * unitValue)
      ).toFixed(2),
      orderItemsDetails: selectedItem.orderItemsInfo,
    };

    addOrderItemLoad(newItem);

    setSelectedItem("");
    setQuantity("");
    setTargetValue("");
    setUnitValue("");
  };

  return (
    <>
      <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 min-h-[330px] text-boldGray opacity-90">
        <div className="overflow-x-auto max-w-[1560px] custom-scrollbar">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="uppercase bold text-center text-base md:text-xs xl:text-base">
                <th className="py-4 w-[6%]">índice</th>
                <th className="py-4 w-[13%]">Item</th>
                <th className="py-4 w-[13%]">Quantidade</th>
                <th className="py-4 w-[13%]">Valor alvo</th>
                <th className="py-4 w-[13%]">Valor unitário</th>
                <th className="py-4 w-[13%]">Total</th>
                <th className="py-4 w-[13%]">Dólar médio</th>
                <th className="py-4 w-[13%]">Custo em R$</th>
              </tr>
            </thead>
          </table>
          <div className="overflow-y-auto max-h-[130px] mt-2 custom-scrollbar">
            <table className="table-auto border-collapse w-full">
              <tbody className="space-y-4">
                {orderItemsLoad.map((orderItem, index) => (
                  <tr
                    key={index}
                    className="text-center bg-[#E7E7E7] w-full h-[64px] md:text-xs xl:text-base "
                  >
                    <td className="py-4 w-[7%]">{index + 1}</td>
                    <td className="py-4 w-[13%] ">
                      <div className="line-clamp-2">{orderItem.name}</div>
                    </td>
                    <td className="py-4 w-[13%] ">{orderItem.quantity}</td>
                    <td className="py-4 w-[13%] ">
                      $ {orderItem.target_value}
                    </td>
                    <td className="py-4 w-[13%] ">$ {orderItem.unit_value}</td>
                    <td className="py-4 w-[13%] ">$ {orderItem.total_value}</td>
                    <td className="py-4 w-[13%] ">
                      R$ {orderItem.average_dollar_cost}
                    </td>
                    <td className="py-4 w-[13%] ">
                      R$ {orderItem.total_value_in_real}
                    </td>
                    <td className="py-4 w-[3%] ">
                      <button
                        className="text-red-500 w-8 "
                        onClick={() => removeOrderLoadItem(index)}
                        type="button"
                      >
                        <FaMinusSquare />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="w-full">
          <div className="h-[20px]"></div>
          <div className="bg-white text-center h-[60px] rounded-md flex flex-wrap md:text-xs xl:text-base">
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <select
                id="productSelect"
                value={selectedItem?.id || ""}
                onChange={(e) => {
                  const product = orderItemsFromApi.find(
                    (item) => item.id === parseInt(e.target.value)
                  );
                  setSelectedItem(product);
                }}
              >
                <option value="" disabled>
                  Selecione um produto
                </option>
                {orderItemsFromApi.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.product_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Quantidade"
                type="text"
                className="text-center focus:outline-none w-full"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Valor alvo"
                type="text"
                value={targetValue}
                readOnly
                className="text-center focus:outline-none w-full"
              />
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Valor unitário"
                type="text"
                value={unitValue}
                readOnly
                className="text-center focus:outline-none w-full"
              />
            </div>

            <div className="flex justify-center items-center py-4 px-2 w-[200px]">
              <button
                className="flex justify-center items-center"
                type="button"
                onClick={() => onHandleAddOrderLoadItems()}
              >
                <img src={plusIcon} alt="Adicionar" />
              </button>
            </div>
          </div>
          {errorMessage && (
            <p className="text-center pt-4 text-red-500">{errorMessage}</p>
          )}
        </div>
      </div>
    </>
  );
};

export default AddOrderLoad;
